import * as React from 'react';

import BaseIcon from 'shared/newComponents/icons/BaseIcon';
import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

const CloudPaymentsIcon: React.FC<CommonIconProps> = (
  props: CommonIconProps
) => {
  return (
    <BaseIcon
      iconSize={IconSize.L}
      svgProps={{ viewBox: '0 0 26 26' }}
      {...props}
    >
      <path
        d="M21.4078 21.4078C26.3051 16.5104 26.3052 8.57032 21.4078 3.67299C16.5105 -1.22433 8.57037 -1.22433 3.67297 3.673C-1.22432 8.57032 -1.22432 16.5104 3.67297 21.4078C8.57037 26.3051 16.5105 26.3051 21.4078 21.4078Z"
        fill="#6496DC"
      />
      <path
        d="M9.84619 16.0456L17.9674 7.92438C18.1681 7.72344 18.4064 7.56403 18.6687 7.45527C18.931 7.34651 19.2122 7.29053 19.4962 7.29053C19.7802 7.29053 20.0614 7.34651 20.3237 7.45527C20.586 7.56403 20.8243 7.72344 21.025 7.92438H21.0297C21.4342 8.33055 21.6613 8.88043 21.6613 9.45365C21.6613 10.0268 21.4342 10.5767 21.0297 10.9829L15.9708 16.0456C15.1582 16.8569 14.0568 17.3125 12.9085 17.3125C11.7602 17.3125 10.6589 16.8569 9.84619 16.0456Z"
        fill="white"
      />
      <path
        d="M15.2342 9.03421L7.11291 17.1555C6.91211 17.3565 6.67371 17.5159 6.41131 17.6247C6.14891 17.7334 5.86771 17.7894 5.58361 17.7894C5.29961 17.7894 5.01831 17.7334 4.75591 17.6247C4.49351 17.5159 4.25511 17.3565 4.05431 17.1555C3.85341 16.9547 3.69391 16.7163 3.58521 16.4539C3.47641 16.1915 3.42041 15.9103 3.42041 15.6262C3.42041 15.3422 3.47641 15.0609 3.58521 14.7985C3.69391 14.5361 3.85341 14.2977 4.05431 14.0969L9.11331 9.03797C9.92531 8.22733 11.0256 7.77171 12.1729 7.771C13.3203 7.7703 14.4212 8.22456 15.2342 9.03421Z"
        fill="white"
      />
    </BaseIcon>
  );
};

export default CloudPaymentsIcon;
